
export default {
  data() {
    return {};
  },
  methods: {
    setAriaLabelledByForSelect(ref: any, id: string) {
      if (ref && ref.$refs && ref.$refs.input && ref.$refs.input.offsetParent) {
        ref.$refs.input.offsetParent.setAttribute("aria-labelledby", id);
      }
    },
  },
};
